<template>
  <v-dialog
    v-model="isDialogVisible"
    persistent
    width="500"
  >
    <v-card>
      <v-card-title class="headline">
        Error
      </v-card-title>
      <v-card-text>
        Lo sentimos, han ocurrido uno o más errores:<br />
        <ul id="example-1">
          <li
            v-for="(item, key) in errorDetail"
            :key="key"
          >
            {{ item }}
          </li>
        </ul>
        Por favor de intentar de nuevo más tarde.
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="error"
          outlined
          @click="closeForm"
        >
          Cerrar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { computed } from '@vue/composition-api'
import store from '@/store'

export default {
  setup() {
    const isDialogVisible = computed(() => store.state.errors.showDialog)
    const errorDetail = computed(() => store.state.errors.error)

    const closeForm = () => {
      store.commit('errors/hide')
    }

    return {
      isDialogVisible,
      errorDetail,
      closeForm,
    }
  },
}
</script>
